import {Workstream, WorkstreamDependencyType, WorkstreamEdit} from 'client';

/**
 * The full edit payload for `workstream` with its sub-workstreams replaced by
 * `dependentIds`, in that order. The edit endpoint replaces the whole
 * workstream, so everything else is carried over as is.
 */
export const buildSubworkstreamsEdit = (
  workstream: Workstream,
  dependentIds: number[]
): WorkstreamEdit => ({
  id: workstream.id,
  name: workstream.name,
  description: workstream.description,
  coaching_rules:
    (workstream as Workstream & {coaching_rules?: string | null}).coaching_rules ?? null,
  start_date: workstream.start_date,
  end_date: workstream.end_date,
  status_cadence: workstream.status_cadence,
  status_due: workstream.status_due,
  links: workstream.links,
  employee_associations: (workstream.employee_associations ?? []).map((association) => ({
    user_id: association.employee.user_id,
    dri: association.dri,
  })),
  privacy: workstream.privacy,
  private_employees: workstream.private_employees?.map(({user_id}) => user_id),
  private_teams: workstream.private_teams?.map(({team_id}) => team_id),
  dependencies: dependentIds
    .filter((id) => id !== workstream.id)
    .map((id, index) => ({
      dependent_id: id,
      type: WorkstreamDependencyType.DEPENDS_ON,
      order: index + 1,
    })),
});

/** The ids of `workstream`'s current sub-workstreams, in their saved order (as the API returns them). */
export const getSubworkstreamIds = (workstream: Workstream): number[] =>
  (workstream.dependencies ?? []).flatMap((dependency) =>
    dependency.dependent ? [dependency.dependent.id] : []
  );
